import React from 'react';
import { Modal } from '../../themes/nzf_2022';
import CloseModal from './close-button';
import Notification from './notification';

const ErrorModal = ({ errorMessage, closeModal }) => {
  return (
    <Modal
      onCloseCB={ () => closeModal(errorMessage) }
      // onCloseCB={ closeModal }
      parsedContent={ (
        <>
          <CloseModal />
          <Notification errorMessage={ errorMessage } containerClasses='pt-20 pb-56' />
        </>
    ) }
    />
  );
};

export default ErrorModal;
